import { CaretLeft, CaretRight } from '@creditornot/cb-icons';
import React from 'react';

export const CollapseIcon = ({ direction, collapsed }: { direction: 'ltr' | 'rtl'; collapsed: boolean }) => {
  if (direction === 'ltr') {
    return collapsed ? <CaretRight /> : <CaretLeft />;
  }
  return collapsed ? <CaretLeft /> : <CaretRight />;
};
